export default "__VITE_ASSET__71b600a8__"